import { css } from 'styled-components';

import { vignetteTokens } from '../../tokens/components/Vignette/tokens';

export const vignetteSizes = {
  sm: css`
    font-size: ${vignetteTokens.CoreFontSizeSmall};
  `,

  md: css`
    font-size: ${vignetteTokens.CoreFontSizeMedium};
  `,

  lg: css`
    font-size: ${vignetteTokens.CoreFontSizeLarge};
  `,
};
